<template>
  <div :style="{'position': 'absolute', 'z-index': '1000'}" class="col-12 col-md-12 text-left bottom-small">
    <b-alert v-if="bandeauShow" :style="{'display': 'flex', 'justify-content': 'space-between'}" show variant="info" dismissible>
      <span><i class="fa fa-info-circle mr-5" aria-hidden="true"></i></span>
      <span class="alert-annul">
        {{ bandeauText }}
      </span>
      <span></span>
    </b-alert>
  </div>
</template>

<script>
import CommonApi from "@/api/commonApi";

export default {
  data () {
    return {
      bandeauText: null,
      bandeauShow: false
    }
  },
  created () {
    let commonApi = new CommonApi()
    commonApi.showBandeauConfigurations()
      .then(bandeauDatas => {
        if (Object.keys(Object.entries(bandeauDatas.data.data)).length !== 0) {
          this.bandeauShow = true
          for (const [key, value] of Object.entries(bandeauDatas.data.data)) {
            this.bandeauText = value
          }
        }
      })
  }
}
</script>
